import axios from '../../api/instance.js'

export default axios
